export default function StrengthsSection() {
  const strengths = [
    {
      icon: 'ri-time-line',
      number: '30+',
      label: '년 경력',
      description: '방산시장에서 30여 년간 목형을 제작하며 성장해온 전문기업'
    },
    {
      icon: 'ri-team-line',
      number: '100%',
      label: '숙련된 기술진',
      description: '장기근속 직원들의 전문성과 노하우로 최고의 품질 보장'
    },
    {
      icon: 'ri-stack-line',
      number: '다품종',
      label: '생산 가능',
      description: '소량 맞춤 제작부터 대량 생산까지 유연한 대응'
    },
    {
      icon: 'ri-map-pin-line',
      number: '전국',
      label: '거래처',
      description: '전국에 거래처를 두고 업계 최고의 제품 생산'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-800 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">재기목형의 강점</h2>
          <p className="text-lg text-slate-300">신뢰와 품질로 증명된 경쟁력</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-amber-500/20 rounded-full mb-6 mx-auto group-hover:bg-amber-500 transition-all duration-300">
                <i className={`${strength.icon} text-4xl text-amber-400 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="text-5xl font-bold text-amber-400 mb-2">{strength.number}</div>
              <div className="text-xl font-semibold text-white mb-3">{strength.label}</div>
              <p className="text-slate-300 text-sm leading-relaxed">{strength.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
          <p className="text-white text-center text-lg leading-relaxed">
            장기근속 직원들의 숙련된 기술과 전문성으로 특수목형 제작 및 개발에 힘쓰고 있으며,<br className="hidden md:block" />
            전국에 거래처를 두고 <strong className="text-amber-400">업계 최고의 제품</strong>을 생산하고 있습니다.
          </p>
        </div>
      </div>
    </section>
  );
}
